<template>
  <v-row justify="center">
    <v-dialog
      v-model="displaySelf"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Добавление пользователя в команду</span>
        </v-card-title>
        <v-card-text>
          <v-list-item-title>{{ filterSet.model.title }}</v-list-item-title>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                :sm="12"
              >
                <WBDLaborerListFilterComponent
                  :remote-list="getCurrentUser"
                  :remote-selected-option="''"
                  @onLaborerSelectorFilterChange="onLaborerSelectorFilterChange"
                />
              </v-col>
              <!--              <v-col-->
              <!--                cols="12"-->
              <!--                :sm="6"-->
              <!--              >-->
              <!--                <v-select-->
              <!--                  v-model="model.isPrioritized"-->
              <!--                  :items="getBlockTypeList"-->
              <!--                  label="Персональщик"-->
              <!--                  :item-text="'title'"-->
              <!--                  :item-value="'id'"-->
              <!--                  return-object-->
              <!--                  required-->
              <!--                />-->
              <!--              </v-col>-->
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="warning"
            text
            @click="$emit('onCloseOfficeStaffFormModal')"
          >
            Отменить
          </v-btn>
          <v-btn
            :disabled="!canSave"
            text
            outlined
            rounded
            color="success"
            @click="save"
          >
            {{ `Добавить` }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import WBDLaborerListFilterComponent from '@/components/common/filter/laborer-filter'
import OfficeStaffMixin from '@/mixins/office-staff-mixin'
export default {
  name: 'OfficeStaffCreateModal',
  components: { WBDLaborerListFilterComponent },
  mixins: [OfficeStaffMixin],
  props: {
    displaySelf: {
      type: Boolean,
      default: false,
    },
    saveCallback: {
      type: Function,
    },
    filterSet: {
      type: Object,
      default: () => (
        {
          level: null,
          model: null,
          user: null,
        }
      )
    }
  },
  data: () => ({
    model: {
      id: null,
      office: null,
      user: null,
      isPrioritized: null,
    }
  }),
  computed: {
    canSave () {
      const { user } = this.model
      return !!user
    },
    getCurrentUser () {
      if (this.filterSet.user) {
        return [this.filterSet.user]
      }

      return []
    },
    getModelTitle () {
      return this.filterSet.model.title
    },
    getBlockTypeList () {
      return [
        { id: '0', title: `Нет` },
        { id: '1', title: `ДА` },
      ]
    },
  },
  watch: {
    model: {
      handler (val) {},
      deep: true,
    },
  },
  created () {
    this.model.office = this.filterSet.model.id
    if (this.filterSet.user) {
      this.model.user = this.filterSet.user.id
    }
  },
  methods: {
    onLaborerSelectorFilterChange (data) {
      this.model.user = data
    },
    async save () {
      try {
        await this.proceedCreate(
          {
            ...this.model,
            isPrioritized: !!this.model.isPrioritized && this.model.isPrioritized.id === '1'
          }, this.saveCallback)
        this.$emit('onUserInOfficeStaff')
      } catch (error) {
        console.log(error)
        this.$emit('onUserInOfficeStaff')
      }
    },
  }
}
</script>
